import { doMutation } from "../../core-module/util/graphqlHelper";

export const uploadTrainingModuleContentImage = image => {
  const mutation = require("../api/mutation/uploadTrainingModuleContentImage.gql");
  const variables = { image };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) return { data: data.uploadTrainingModuleContentImage };
    else if (error) return { error: JSON.stringify(error) };
  });
};
